var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header',{attrs:{"Title":_vm.title}}),_c('v-main',[_c('Body',{attrs:{"Params":_vm.Parameters}})],1),_c('Footer',{attrs:{"Title":"OUG Portals Platform"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }